import railsConfig from "../../../RailsConfig";
import { PAGE_ID } from "./config";

export const API_MAPPING = {
  GET: {
    [PAGE_ID.CANCEL_BOOKING]: railsConfig.whyCancelFetchURL,
    [PAGE_ID.OTHER_ISSUES]: railsConfig.feedbackFetchURL,
    [PAGE_ID.WRONG_CREDENTIALS]: railsConfig.wrongCredentials,
    [PAGE_ID.BOOKING_DETAILS]: railsConfig.ppfReview,
    [PAGE_ID.DIFFERENT_IRCTC_USERNAME]: railsConfig.changeUserNameURL,
  },
  POST: {
    [PAGE_ID.CANCEL_BOOKING]: railsConfig.whyCancelPostURL,
    [PAGE_ID.OTHER_ISSUES]: railsConfig.feedbackPostURL,
  }
};
